export class UserProfile {
  public constructor(
    public id: string,
    public firstName: string,
    public lastName: string,
    public email: string,
    public companies: UserProfileCompany[]
  ) {}

  public get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  public static from(data: UserProfile): UserProfile {
    return new UserProfile(
      data.id,
      data.firstName,
      data.lastName,
      data.email,
      data.companies.map(company => UserProfileCompany.from(company))
    );
  }
}

export class UserProfileCompany {
  public constructor(
    public id: string,
    public name: string,
    public roles: number[],
    public legalEntities: LegalEntity[]
  ) {}

  public static from(data: UserProfileCompany): UserProfileCompany {
    return new UserProfileCompany(
      data.id,
      data.name,
      data.roles,
      (data.legalEntities ?? []).map(legalEntity => LegalEntity.from(legalEntity))
    );
  }

  public toCompanyContext(): CompanyContext {
    return new CompanyContext(this.id, this.name);
  }
}

export class LegalEntity {
  public constructor(
    public id: string,
    public name: string
  ) {}

  public static from(data: LegalEntity): LegalEntity {
    return new LegalEntity(data.id, data.name);
  }
}

export class CompanyContext {
  public constructor(
    public id: string,
    public name: string
  ) {}

  public static from(data: CompanyContext): CompanyContext {
    return new CompanyContext(data.id, data.name);
  }
}

export class CompanySettings {
  public constructor(
    public companyEntityId: string,
    public pgaAnalysis: boolean,
    public adCvdAnalysis: boolean,
    public exportToPortalUnicoJson: boolean,
    public exportToThomsonReutersJson: boolean,
    public endUse: boolean,
    public requestCategory: boolean,
    public primaryService: CompanyPrimaryService,
    public specialCustomsCode: boolean,
    public canadianBrokerData: boolean
  ) {}

  public static from(data: CompanySettings): CompanySettings {
    return new CompanySettings(
      data.companyEntityId,
      data.pgaAnalysis,
      data.adCvdAnalysis,
      data.exportToPortalUnicoJson,
      data.exportToThomsonReutersJson,
      data.endUse,
      data.requestCategory,
      data.primaryService,
      data.specialCustomsCode,
      data.canadianBrokerData
    );
  }
}

export enum CompanyPrimaryService {
  Classification = 0,
  CBAM = 1,
}
